import { inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { CanActivateFn, Router, UrlTree } from '@angular/router'
import { firstValueFrom } from 'rxjs'
import { AuthService } from '../services/auth.service'
import { UserRole } from '../../shared/interfaces/user.interface'
import { ApiResponse } from '../../shared/interfaces/api.interface'
import { environment } from '../../../environments/environment'

interface ScoutReach { package?: string, scouting?: boolean }

/**
 * The scouting pages by address (audit 27/10/2026), matching the menu and the server: a
 * Director – club only with the scouting option (else his first page); a Scout – agent has
 * My players only, so Find players, My lists and My competitions send him there. Route data
 * `agents: true` lets an agent in (My scouting is his My players); `allDirectors: true` keeps a
 * page open to every director (Competitions).
 */
export const scoutingGuard: CanActivateFn = async (route): Promise<boolean | UrlTree> => {
  const auth = inject(AuthService)
  const router = inject(Router)
  const http = inject(HttpClient)
  const role = auth.currentUser()?.role
  if (role !== UserRole.DIRECTOR && role !== UserRole.SCOUT) return true
  // Pages every director has anyway (Competitions): only agents are turned away.
  if (role === UserRole.DIRECTOR && route.data?.['allDirectors']) return true
  try {
    const r = await firstValueFrom(http.get<ApiResponse<ScoutReach>>(`${environment.apiUrlV2}/access/reach`))
    if (role === UserRole.DIRECTOR) return r.data?.scouting ? true : router.createUrlTree(['/home'])
    if (r.data?.package === 'scout_chosen_players' && !route.data?.['agents']) return router.createUrlTree(['/scout'])
    return true
  } catch {
    return true // the server still refuses what it must
  }
}
